import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../../Operations/components/Table';
import { loadOperationsAction } from '../../../Operations/actions';
import CardHeader from './Header';

class Card extends Component {
  componentWillMount() {
    const { dispatch, operations } = this.props;

    if (operations.length == 0) {
      const filters = [
        {filter: "first", value: 10},
        {filter: "skip", value: 0}
      ]

      dispatch(loadOperationsAction(filters))
    }
  }

  render() {
    return (
      <div className="card shadow">
        <CardHeader />
        <Fragment>
          <Table operations={this.props.operations} />
        </Fragment>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { zwallet } = state;
  return { operations: zwallet.extract.operations }
}

export default connect(mapStateToProps)(Card);


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/components/LatestOperations/index.js